import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.zabbix');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-zabbix',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.zabbix/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}`],
})
export class PageKieraZabbixComponent implements OnInit {
    public zabbixUrl: string = '';
    public zabbixUsername: string = 'Admin';
    public zabbixPassword: string = '';
    public zabbixEmbedUrl: string = '/zabbix/index.php';
    public showConfig: boolean = false;
    public autoLoginUrl: string = '';
    public loadError: string = '';
    public targetPath: string = '';
    public returnUrl: string = '';
    public contextHost: string = '';
    public contextHostId: string = '';
    public contextRack: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        const params = new URLSearchParams(location.search);
        this.targetPath = params.get('target') || '';
        const requestedReturn = params.get('return') || '';
        this.returnUrl = requestedReturn.startsWith('/kiera/operations-rack') ? requestedReturn : '';
        this.contextHost = params.get('host') || '';
        this.contextHostId = params.get('hostid') || '';
        this.contextRack = params.get('rack') || '';
        let res = await wiz.call("config");
        if (res.code === 200) {
            this.zabbixUrl = res.data.url || '';
            this.zabbixUsername = res.data.username || 'Admin';
            this.zabbixPassword = '';
            this.zabbixEmbedUrl = res.data.embed_url || '/zabbix/index.php';
            if (this.zabbixUrl) {
                await this.openZabbixIframe();
            }
        }
        await this.service.render();
    }

    public async saveConfig() {
        this.loadError = '';
        let res = await wiz.call("save_config", {
            url: this.zabbixUrl,
            username: this.zabbixUsername,
            password: this.zabbixPassword
        });
        if (res.code === 200) {
            this.zabbixPassword = '';
            this.showConfig = false;
            if (this.zabbixUrl) {
                this.zabbixEmbedUrl = res.data?.embed_url || '/zabbix/index.php';
                await this.openZabbixIframe();
            } else {
                this.autoLoginUrl = '';
            }
            await this.service.render();
        }
    }

    public onIframeError() {
        this.loadError = 'Failed to load Zabbix. Check if the server is accessible and URL is correct.';
        this.service.render();
    }

    public async openZabbixIframe() {
        this.autoLoginUrl = '';
        this.loadError = '';
        const res = await wiz.call('auto_login', { target: this.targetPath });
        if (res.code !== 200) {
            this.loadError = res.data?.message || 'Failed to prepare the Zabbix session. Check the URL and account.';
            await this.service.render();
            return;
        }

        const embedUrl = res.data?.embed_url || this.zabbixEmbedUrl || '/kiera/monitor-proxy/index.php';
        const separator = embedUrl.includes('?') ? '&' : '?';
        this.autoLoginUrl = `${embedUrl}${separator}t=${Date.now()}`;
        await this.service.render();
    }

    public backToRackView() {
        if (this.returnUrl) this.service.href(this.returnUrl);
    }
}

export default PageKieraZabbixComponent;
